import type { GeoCountryFlagType } from './types';
import { classes } from '../../utils/classes';

export const GeoCountryFlag = ({ flag, big }: GeoCountryFlagType) => {
  switch (flag) {
    case 'at':
      return <span className={classes('icon-emp-flag-at', big && 'size-4')} />;
    case 'de':
      return <span className={classes('icon-emp-flag-de', big && 'size-4')} />;
    case 'ch':
      return <span className={classes('icon-emp-flag-ch', big && 'size-4')} />;
    case 'it':
      return <span className={classes('icon-emp-flag-it', big && 'size-4')} />;
    default:
      return null;
  }
};
